import React from "react";
import ReactSelect, { components } from "react-select";
import ReactAsyncSelect from "react-select/async";
import CustomOption from "./CustomOption";

const CustomSelect = ({ value, options, onChange, async, loadOptions }) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  if (async) {
    return (
      <ReactAsyncSelect
        value={value}
        defaultOptions
        cacheOptions
        loadOptions={loadOptions}
        isClearable
        components={{
          Option: CustomOption,
        }}
        onChange={handleChange}
        formatOptionLabel={(data) => (
          <div className="country-option">
            <img
              src={
                data.image ||
                "https://upload.wikimedia.org/wikipedia/commons/thumb/2/2c/Default_pfp.svg/2048px-Default_pfp.svg.png"
              }
              alt="country"
              className="user-image rounded"
              style={{
                width: "25px",
                height: "25px",
                borderRadius: "50%",
                marginRight: "5px",
              }}
            />
            <span>&nbsp; {data.label}</span>
          </div>
        )}
      />
    );
  }
  return (
    <ReactSelect
      value={value}
      options={options}
      onChange={handleChange}
      isClearable={true}
      formatOptionLabel={(data) => (
        <div className="country-option">
          <img
            src={data.image}
            alt="country"
            className="user-image rounded"
            style={{
              width: "25px",
              height: "25px",
              borderRadius: "50%",
              marginRight: "5px",
            }}
          />
          <span>&nbsp; {data.label}</span>
        </div>
      )}
    />
  );
};

export default CustomSelect;



// WEBPACK FOOTER //
// ./src/components/multiselectcustom/CustomSelect.js